<div class="d-flex flex-row">
    <img [attr.src]="comment().player.id | avatarUrl" class="comment-avatar mt-2 mx-2" [attr.alt]="comment().player.displayName" />
    <div class="card w-100 p-2 my-1">
        <strong>{{ comment().player.displayName }}</strong>
        @if (comment().imageUrl) {
            <img [attr.src]="comment().imageUrl" class="comment-img mb-1" />
        }
        <small>{{ comment().message }}</small>
    </div>
</div>
